import { render, staticRenderFns } from "./GeneralObject.vue?vue&type=template&id=254725ad&"
import script from "./GeneralObject.vue?vue&type=script&lang=js&"
export * from "./GeneralObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports